import ApiService from "@/core/services/api.service";

// action types
export const FETCH_DESTINATIONS = "fetchDestinations";
export const FETCH_DESTINATION = "fetchDestination";
export const STORE_DESTINATION = "storeDestination";
export const UPDATE_DESTINATION = "updateDestination";
export const DESTROY_DESTINATION = "destroyDestination";

// mutation types
export const SET_DESTINATIONS = "setDestinations";
export const SET_DESTINATIONS_PAGINATION = "setDestinationsPagination";
export const SET_DESTINATION = "setDestination";

const state = {
  destinations: [],
  destinationsPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  },
  destination: {},
  destinationNames: {
    custom: "RTMP",
    facebook: "فیس‌بوک",
    instagram: "اینستاگرام",
    youtube: "بوتیوب",
    twitter: "توییتر",
    twitch: "توییچ",
    aparat: "آپارات",
    rubika: "روبیکا",
    soroushplus: "سروش پلاس",
    tekye: "تکیه",
    arvancload: "ابر آروان",
    shad: "شاد",
    telegram: "تلگرام"
  },
  destinationValues: {
    custom: 1,
    facebook: 2,
    instagram: 3,
    youtube: 4,
    twitter: 5,
    twitch: 6,
    aparat: 7,
    rubika: 8,
    soroushplus: 9,
    tekye: 10,
    arvancload: 11,
    shad: 12,
    telegram: 13
  },
  destinationTypes: {
    1: "custom",
    2: "facebook",
    3: "instagram",
    4: "youtube",
    5: "twitter",
    6: "twitch",
    7: "aparat",
    8: "rubika",
    9: "soroushplus",
    10: "tekye",
    11: "arvancload",
    12: "shad",
    13: "telegram"
  }
};

const getters = {
  destinations(state) {
    return state.destinations;
  },

  destinationsPagination(state) {
    return state.destinationsPagination;
  },

  destination(state) {
    return state.destination;
  },

  destinationNames(state) {
    return state.destinationNames;
  },

  destinationValues(state) {
    return state.destinationValues;
  },

  destinationTypes(state) {
    return state.destinationTypes;
  }
};

const actions = {
  [FETCH_DESTINATIONS](context, payload) {
    let params = {
      page: context.state.destinationsPagination.currentPage
    };

    if (payload.user !== undefined) {
      params.user = payload.user;
    }

    if (payload.editable !== undefined) {
      params.editable = payload.editable;
    }

    return new Promise((resolve, reject) => {
      ApiService.query("destinations", {
        params: params
      })
        .then(({ data }) => {
          context.commit(SET_DESTINATIONS, data.data);
          context.commit(SET_DESTINATIONS_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_DESTINATION](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get("destinations", id)
        .then(({ data }) => {
          context.commit(SET_DESTINATION, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [STORE_DESTINATION](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post("destinations", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [UPDATE_DESTINATION](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.update("destinations", payload.id, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [DESTROY_DESTINATION](context, id) {
    return new Promise(resolve => {
      ApiService.delete(`destinations/${id}`).then(({ data }) => {
        resolve(data);
      });
    });
  }
};

const mutations = {
  [SET_DESTINATIONS](state, data) {
    state.destinations = data;
  },
  [SET_DESTINATIONS_PAGINATION](state, data) {
    state.destinationsPagination = data;
  },
  [SET_DESTINATION](state, destination) {
    state.destination = destination;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
